import React from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import classNames from "classnames";

import Icon from "components/Library/Icon";
import Ad from "components/Library/Ad";

import { getSecondsIn, setCookieParams } from "utils/cookies";
import { COOKIES } from "../../../config/constants";

import styles from "./CookieWarning.css";

class CookieWarning extends React.Component {
  constructor(props) {
    super(props);

    this.elementId = "ad-cookie-warning";
    this.state = {
      isVisible: false,
      seenCookieWarning: false,
    };
  }

  componentDidMount() {
    const { cookies } = this.props;
    this.setState({
      seenCookieWarning: cookies.get(COOKIES.SEEN_COOKIE_WARNING),
    });
  }

  onSlotRenderEnded = ({ isEmpty }) => {
    if (!isEmpty) {
      this.setState({
        isVisible: true,
      });
    }
  };

  onClose = () => {
    this.props.cookies.set(COOKIES.SEEN_COOKIE_WARNING, true, {
      ...setCookieParams(),
      maxAge: getSecondsIn({ days: 30 }),
    });
    this.setState({
      isVisible: false,
    });
  };

  render() {
    if (this.state.seenCookieWarning) return null;

    return (
      <div
        className={classNames(styles.root, {
          [styles.isActive]: this.state.isVisible,
        })}
      >
        <div className={styles.adSlot}>
          <Ad
            adUnit="cookie"
            outOfPage={true}
            id={this.elementId}
            onSlotRenderEnded={this.onSlotRenderEnded}
            renderWhenViewable={false}
          />
        </div>

        <div className={styles.message}>
          <span>
            This site uses cookies to enhance your reading experience. By using
            this site, you consent to our use of cookies.
          </span>
          <span className={styles.okay} onClick={this.onClose}>
            Okay
          </span>
        </div>
        <button onClick={this.onClose} className={styles.closeButton}>
          <Icon name="close" className={styles.closeIcon} />
        </button>
      </div>
    );
  }
}

CookieWarning.propTypes = {
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(CookieWarning);
